var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_589_12000)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 132,
    rx: 66,
    fill: "#BA1A1A",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0003 7.6665C33.8587 7.6665 7.66699 33.8582 7.66699 65.9998C7.66699 98.1415 33.8587 124.333 66.0003 124.333C98.142 124.333 124.334 98.1415 124.334 65.9998C124.334 33.8582 98.142 7.6665 66.0003 7.6665ZM85.6003 79.4165C87.292 81.1082 87.292 83.9082 85.6003 85.5998C84.7253 86.4748 83.617 86.8832 82.5087 86.8832C81.4003 86.8832 80.292 86.4748 79.417 85.5998L66.0003 72.1832L52.5837 85.5998C51.7087 86.4748 50.6003 86.8832 49.492 86.8832C48.3837 86.8832 47.2753 86.4748 46.4003 85.5998C44.7087 83.9082 44.7087 81.1082 46.4003 79.4165L59.817 65.9998L46.4003 52.5832C44.7087 50.8915 44.7087 48.0915 46.4003 46.3998C48.092 44.7082 50.892 44.7082 52.5837 46.3998L66.0003 59.8165L79.417 46.3998C81.1087 44.7082 83.9087 44.7082 85.6003 46.3998C87.292 48.0915 87.292 50.8915 85.6003 52.5832L72.1837 65.9998L85.6003 79.4165Z",
    fill: "#BA1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_589_12000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 132,
    rx: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.a803ecbcadb6c7beeb93578e3df82e19.svg";
export { ForwardRef as ReactComponent };